// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"be80091d","370":"09fb11f9"}[chunkId] + ".chunk.css";
};